import * as React from 'react'
import * as Lodash from 'lodash'

import { getOption } from '../utils/get-option'
import { Optionset } from '../interfaces/components/options'
import { Icon, SxProps, Theme } from '@design/pt-ui'

interface IProps {
  id: string
  icons: Optionset
  // TODO: Match type to that of material-ui without duplicate definition
  fontSize?: 'inherit' | 'medium' | 'large'
  className?: string
  classes?: {}
  sx?: SxProps<Theme>
}

export default function SomethingIcon(props: IProps) {
  return (
    <Icon
      fontSize={props.fontSize}
      sx={props.sx}
      {...Lodash.omit(props, ['icons', 'sx'])}>
      {getOption(props.id, props.icons)}
    </Icon>
  )
}
